import { useEffect, useRef } from 'react';

const cacheDuration = 30; // in seconds

export const useForceUpgrade = () => {
    const lastCheckedAt = useRef(0);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const handleVisibilityChange = async () => {
            if (document.hidden) return;

            const now = Date.now();
            if (now - lastCheckedAt.current <= cacheDuration * 1000) return;

            try {
                const response = await fetch('/Config/upgrade.json', { cache: 'no-store', signal });
                const { latestVersion, latestConfigVersion, forceUpgrade, forceUpgradeWhenNotLoginOnly } =
                    await response.json();
                // ensure the pipeline have correctly assigned the version number before deciding whether to force reload
                const validVersions =
                    !window.globalConfig.VERSION.startsWith('@@@') &&
                    !latestVersion.startsWith('@@@') &&
                    !latestConfigVersion.startsWith('@@@');

                // ignore timestamp from version, which might be different when load balancing between bucket 1 and 2
                const normalizedVersion = window.globalConfig.VERSION.split('-').slice(0, 2).join('-');
                const normalizedLatestVersion = latestVersion.split('-').slice(0, 2).join('-');
                // ignore Jenkins job number, if exist, which might be different when load balancing between bucket 1 and 2
                const normalizedConfigVersion = /^\d+-.*$/.test(window.globalConfig.CONFIG_VERSION)
                    ? window.globalConfig.CONFIG_VERSION.split('-').slice(1).join('-')
                    : window.globalConfig.CONFIG_VERSION;
                const normalizedLatestConfigVersion = /^\d+-.*$/.test(latestConfigVersion)
                    ? latestConfigVersion.split('-').slice(1).join('-')
                    : latestConfigVersion;

                lastCheckedAt.current = now;

                if (
                    validVersions &&
                    !(
                        normalizedVersion === normalizedLatestVersion &&
                        normalizedConfigVersion === normalizedLatestConfigVersion
                    ) &&
                    (forceUpgrade || (forceUpgradeWhenNotLoginOnly && sessionStorage.getItem('is_logon') !== '1'))
                ) {
                    console.debug(
                        `Latest version: ${latestVersion}; Current version: ${window.globalConfig.VERSION}; Triggering force refresh`
                    );

                    window.removeEventListener('beforeunload', window.secDialogFn);
                    history.go(0); // workaround windows.location.reload() some times will refuse to reload the page for some reasons
                }
            } catch (error) {
                console.debug('fail to force upgrade', error);
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            controller.abort();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
};
